module.exports = __webpack_public_path__ + "static/media/6.664db42f.jpg";